import React from 'react'
import { Field } from 'formik'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { fonts } from 'app/common/typography'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { Chevron } from 'app/assets/icons'

export type SelectOption = {
    code: string,
    label: string,
    disabled?: boolean
}

type Props = {
    name: string,
    options: Array<SelectOption>,
    placeholderKey?: string,
    handleChange: (e: SyntheticEvent<HTMLSelectElement>) => void,
    className?: string,
    intl: IntlShape
}

const Select = injectIntl((props: Props) => {
    const {
        name,
        options,
        placeholderKey,
        className,
        handleChange,
        intl
    } = props

    return (
        <Dropdown className={className}>
            <StyledSelect
                component="select"
                name={name}
                onChange={e => handleChange(e)}>
                {placeholderKey && (
                    <Option value="">
                        {intl.formatMessage({ id: placeholderKey })}
                    </Option>
                )}
                {options.map((option: SelectOption) => (
                    <Option key={option.code} value={option.code}>
                        {option.label}
                    </Option>
                ))}
            </StyledSelect>
            <StyledChevron
                className={className}
                direction="down"
                color={colors.red}
            />
        </Dropdown>
    )
})

const Dropdown = styled.div`
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
    &.error {
        border: 1px solid ${colors.red};
        border-radius: 4px;
        height: 40px;
        padding: 5px 10px;
    }
    &.hour {
        width: 50px;
        align-items: flex-end;
        position: absolute;
        left: 210px;
        top: 45px;
        ${media.medium`
            top: 55px;
        `};
    }
    &.department,
    &.restaurant {
        width: 220px;
    }
`

const StyledSelect = styled(Field)`
    outline: 0;
    border: none;
    width: 100%;
    -webkit-appearance: none;
    font-family: ${fonts.roboto};
    background: transparent;
    font-size: 16px;
    padding: 0;
    cursor: pointer;
`

const Option = styled.option`
    font-family: ${fonts.roboto};
    background: white;
    -webkit-appearance: none;
`

const StyledChevron = styled(Chevron)`
    position: absolute;
    right: 5px;
    z-index: -1;
    &.hour {
        top: -3px;
        right: 0;
    }
`

export { Select }
